import { render, staticRenderFns } from "./UserMenuProfileButton.vue?vue&type=template&id=47b7f530&scoped=true&"
import script from "./UserMenuProfileButton.vue?vue&type=script&lang=js&"
export * from "./UserMenuProfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7f530",
  null
  
)

export default component.exports